import { createMuiTheme } from '@material-ui/core/styles';

const Theme = {
  palette: {
    primary: {
      light: '#e24479',
      main: '#e00051',
      dark: '#a5164d',
    },
    secondary: {
      main: '#15d0c5',
      dark: '#0bb5aa',
    },
    text: {
      light: 'white',
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: '#87919d',
    },
    background: {
      default: '#fff',
      modal: 'white',
    },
  },
  typography: {
    fontFamily: 'sofia, sans-serif',
    fontSize: 15,
  },
  overrides: {
    MuiDivider: {
      root: {
        margin: '10px 0',
      },
    },
    MuiChip: {
      colorSecondary: {
        height: 24,
        fontSize: '0.8rem',
        color: '#15d0c5',
        backgroundColor: '#f4f4f4',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'initial',
      },
      containedPrimary: {
        borderRadius: 20,
      },
      label: {
        position: 'relative',
        top: '1px',
      },
    },
    MuiIconButton: {
      root: {
        padding: 0,
      },
    },
    MuiDialog: {
      root: {
        paddingRight: '0 !important',
        maxHeight: 900,
      },
    },
    MuiTabs: {
      scrollable: {
        '&::-webkit-scrollbar': {
          height: '0',
        },
      },
    },
    MuiTab: {
      root: {
        textTransform: 'initial',
      },
      textColorInherit: {
        opacity: 1,
      },
      wrapper: {
        position: 'relative',
        top: '1px',
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: '12px 14px',
      },
    },
    MuiInputLabel: {
      outlined: {
        transform: 'translate(14px, 14px) scale(1)',
      },
    },
    MuiInput: {
      input: {
        fontSize: '1.1em',
        fontFamily: 'sofia, sans-serif',
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: 'white',
      },
      colorSecondary: {
        backgroundColor: 'transparent',
      },
    },
    MuiToolbar: {
      root: {
        paddingLeft: '50px',
      },
    },
    MuiTooltip: {
      popper: {
        opacity: 1,
        pointerEvents: 'initial',
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          background: 'transparent',
        },
      },
    },
    MuiCheckbox: {
      root: {
        margin: '5px 5px 0 0',
      },
    },
    MuiTypography: {
      root: {
        textRendering: 'optimizeLegibility',
        fontSmoothing: 'antialiased',
      },
      caption: {
        fontSize: '0.8rem',
      },
      body1: {
        letterSpacing: 1,
      },
      h1: {
        fontFamily: 'sofia-bold',
      },
      h2: {
        fontFamily: 'sofia-bold',
      },
    },
  },
};

export default createMuiTheme(Theme);
